import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import ArticleIcon from '@mui/icons-material/Article';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import QuizIcon from '@mui/icons-material/Quiz';
import EditNoteIcon from '@mui/icons-material/EditNote';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ChatIcon from '@mui/icons-material/Chat';
import InsightsIcon from '@mui/icons-material/Insights';
import CategoryIcon from '@mui/icons-material/Category';
import SchoolIcon from '@mui/icons-material/School';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import DownloadIcon from '@mui/icons-material/Download';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PaymentsIcon from '@mui/icons-material/Payments';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WebhookIcon from '@mui/icons-material/Webhook';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SettingsIcon from '@mui/icons-material/Settings';

import { ROUTES } from './paths';
import { PERMISSIONS as P } from '@/permissions/permissions';

// Sidebar config. Each item declares the permission required to SEE it (filtered by usePermissions).
// A section with no visible children is hidden. See PERMISSION_MATRIX.md → Menu Visibility Rules.
export const MENU = [
  {
    section: 'Overview',
    items: [{ label: 'Dashboard', path: ROUTES.DASHBOARD, icon: DashboardIcon, permission: P.DASHBOARD_READ }],
  },
  {
    section: 'People',
    items: [{ label: 'Users', path: ROUTES.USERS, icon: PeopleIcon, permission: P.USERS_READ }],
  },
  {
    section: 'Content',
    items: [
      { label: 'News', path: ROUTES.NEWS, icon: ArticleIcon, permission: P.CONTENT_READ },
      { label: 'Scraper', path: ROUTES.SCRAPER, icon: CloudSyncIcon, permission: P.SCRAPER_READ },
    ],
  },
  {
    section: 'Learning',
    items: [
      { label: 'Quizzes', path: ROUTES.QUIZZES, icon: QuizIcon, permission: P.QUIZ_READ },
      { label: 'Mains Questions', path: ROUTES.MAINS_QUESTIONS, icon: QuestionAnswerIcon, permission: P.MAINS_READ },
      { label: 'Mains Submissions', path: ROUTES.MAINS, icon: EditNoteIcon, permission: P.MAINS_READ },
    ],
  },
  {
    section: 'AI',
    items: [
      { label: 'Chat Sessions', path: ROUTES.CHATS, icon: ChatIcon, permission: P.AI_READ },
      { label: 'AI Usage', path: ROUTES.AI_USAGE, icon: InsightsIcon, permission: P.AI_READ },
    ],
  },
  {
    section: 'Catalogue',
    items: [
      { label: 'Categories', path: ROUTES.CATEGORIES, icon: CategoryIcon, permission: P.CATEGORIES_READ },
      { label: 'Exams', path: ROUTES.EXAMS, icon: SchoolIcon, permission: P.EXAMS_READ },
      { label: 'Exam Alerts', path: ROUTES.ALERTS, icon: NotificationsActiveIcon, permission: P.ALERTS_READ },
      { label: 'Downloads', path: ROUTES.DOWNLOADS, icon: DownloadIcon, permission: P.DOWNLOADS_READ },
      { label: 'Home Banners', path: ROUTES.BANNERS, icon: ViewCarouselIcon, permission: P.BANNERS_READ },
    ],
  },
  {
    section: 'Billing',
    items: [
      { label: 'Payments', path: ROUTES.PAYMENTS, icon: PaymentsIcon, permission: P.PAYMENTS_READ },
      { label: 'Subscriptions', path: ROUTES.RECURRING_SUBSCRIPTIONS, icon: AutorenewIcon, permission: P.PAYMENTS_READ },
      { label: 'Pro Users', path: ROUTES.SUBSCRIPTIONS, icon: WorkspacePremiumIcon, permission: P.PAYMENTS_READ },
      { label: 'Renewals', path: ROUTES.RENEWALS, icon: ReceiptLongIcon, permission: P.PAYMENTS_READ },
      { label: 'Webhook Logs', path: ROUTES.WEBHOOK_LOGS, icon: WebhookIcon, permission: P.PAYMENTS_READ },
      { label: 'Coupons', path: ROUTES.COUPONS, icon: LocalOfferIcon, permission: P.COUPONS_READ },
    ],
  },
  {
    section: 'System',
    items: [{ label: 'Settings', path: ROUTES.SETTINGS, icon: SettingsIcon, permission: P.SETTINGS_READ }],
  },
];

export default MENU;
